import dayjs from "dayjs";
import * as yup from "yup";

const BroadcastNotificationSchema = yup.object().shape({
  name: yup.string().trim().required("Emri i njoftimit është i detyrueshëm"),
  sendMode: yup.string().oneOf(["now", "schedule"]).required(),
  scheduledAt: yup.string().when("sendMode", {
    is: "schedule",
    then: (schema) =>
      schema
        .required("Zgjidhni datën dhe orën e dërgimit")
        .test(
          "is-future",
          "Koha e dërgimit duhet të jetë të paktën 2 minuta në të ardhmen",
          // dayjs.tz matches how the value is interpreted on submit (the app's
          // display timezone), and the 2-minute floor mirrors the backend rule.
          (value) =>
            !!value && dayjs.tz(value).valueOf() > Date.now() + 2 * 60 * 1000
        ),
    otherwise: (schema) => schema.notRequired()
  }),
  minAppVersion: yup
    .string()
    .trim()
    .notRequired()
    .test(
      "is-version",
      "Versioni duhet të jetë në formatin 1.2.0",
      (value) => !value || /^\d+(\.\d+){1,3}$/.test(value.trim())
    ),
  audienceMode: yup.string().oneOf(["all", "users"]).required(),
  targetUsers: yup.array().when("audienceMode", {
    is: "users",
    then: (schema) => schema.min(1, "Zgjidhni të paktën një përdorues"),
    otherwise: (schema) => schema.notRequired()
  }),
  routeChoice: yup.string().notRequired(),
  customRoute: yup.string().when("routeChoice", {
    is: "custom",
    then: (schema) =>
      schema
        .required("Shkruani rrugën e faqes")
        .test(
          "starts-with-slash",
          "Rruga duhet të fillojë me '/', p.sh. /my-esims",
          (value) => !!value && value.trim().startsWith("/")
        ),
    otherwise: (schema) => schema.notRequired()
  }),
  defaultTitle: yup.string().trim().required("Titulli është i detyrueshëm"),
  defaultBody: yup.string().trim().required("Përmbajtja është e detyrueshme"),
  translations: yup.array().of(
    yup.object().shape({
      applicationLanguage: yup.string().required("Zgjidhni gjuhën"),
      title: yup.string().trim().required("Titulli është i detyrueshëm"),
      body: yup.string().trim().required("Përmbajtja është e detyrueshme")
    })
  )
});

export default BroadcastNotificationSchema;
